class ShowroomDrawer extends HTMLElement {
  constructor() {
    super();
    this.closeButton = this.querySelector("[data-close]");
    this.content = this.querySelector(".showroom-drawer__content");

    this.closeButton?.addEventListener("click", () => this._close());
    this.addEventListener("click", (e) => {
      if (e.target.closest(".showroom-drawer__content")) return;

      this._close();
    });

    this.handleDocumentClick = (e) => {

      if (!document.body.contains(e.target)) return;

      if (!this.content.contains(e.target)) {
        this._close();
      }
    };

    document.addEventListener("click", this.handleDocumentClick);

    this.closeEsc = (e) => {
      if (e.key === "Escape") {
        this._close();
      }
    };

    document.addEventListener("keydown", this.closeEsc);

    document.addEventListener("showroom:open", () => this._open());
    document.addEventListener("showroom:close", () => this._close());

    document.addEventListener("drawer:before-open", (e) => {
      if (e.detail?.name !== "showroom") this._close();
    });
  }

  disconnectedCallback() {
    document.removeEventListener("keydown", this.closeEsc);
    document.removeEventListener("click", this.handleDocumentClick);
  }

  _toggle() {
    this.hasAttribute("open") ? this._close() : this._open();
  }

  _open() {
    if (this.hasAttribute("open")) return;

    document.dispatchEvent(new CustomEvent("markup-modal:close"));

    this.style.display = "block";
    window.requestAnimationFrame(() => {
      this.setAttribute("open", "");
      window.openFullDimmer(this);
      window.lockScroll(this);
      this.returnFocusEl = document.activeElement;
      window.trapFocus(this, this.closeButton);
    });
  }

  _close() {
    if (!this.hasAttribute("open")) return;

    this.removeAttribute("open");
    window.closeFullDimmer(this);

    const onEnd = () => {
      this.removeEventListener("transitionend", onEnd);

      if (this.hasAttribute("open")) return;
      this.style.display = null;
      window.removeTrapFocus(this.returnFocusEl);
      window.unlockScroll(this);
    };
    this.addEventListener("transitionend", onEnd);
  }
}

if (!customElements.get("showroom-drawer")) {
  customElements.define("showroom-drawer", ShowroomDrawer);
}
